import { useLayoutEffect } from 'react';

import config from 'config';

const FOURTHLINE_SCRIPT_ID = 'fourthline-sdk-lib';

export const useFourthlineSdkScript = () => {
  useLayoutEffect(() => {
    if (!document.getElementById(FOURTHLINE_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = FOURTHLINE_SCRIPT_ID;
      script.src = `${config.fourthlineCdnHost}/v1/build/web-sdk-v2.esm.js`;
      script.type = 'module';
      document.head.appendChild(script);
    }
  }, []);
};
